// This is duplicated on the backend.
const MAX_ENVIRONMENTS = 20;
const MAX_ENVIRONMENT_TOKENS = 128;

export { MAX_ENVIRONMENTS, MAX_ENVIRONMENT_TOKENS };
